import styled from "styled-components";

export const StyledDividerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  margin: 10px 0;
  div {
    height: 0.5px;
    background-color: ${({ theme }) => theme.colors.text};
    width: 100%;
  }
  span {
    font-size: 14px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
    color: ${({ theme }) => theme.colors.text};
    margin: 0 10px;
    display: flex;
    min-width: max-content;
  }
`;
